import { render, staticRenderFns } from "./CalendarColorField.vue?vue&type=template&id=422cae9c&scoped=true"
import script from "./CalendarColorField.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarColorField.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalendarColorField.vue?vue&type=style&index=0&id=422cae9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422cae9c",
  null
  
)

export default component.exports